import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import loadable from '@loadable/component';
import ConfigContext from '../../../contexts/ConfigContext';
import { useAddLocationSubscriberMutation } from '../../../redux/slices/locationSlice';

import ErrorBoundary from '../../shared/ErrorBoundary';
import LocationSubscribeForm from './LocationSubscribeForm';

import sidebarStyles from '../../../../stylesheets/public/layouts/SidebarLayout.module.postcss';
import styles from './Location.module.postcss';

const LocationMap = loadable(() => import('./LocationMap'), {
  ssr: false,
  fallback: <div></div>,
});

function LocationSidebar({ location }) {
  const { vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  const [subscribeSuccess, setSubscribeSuccess] = useState(false);
  const [subscribeError, setSubscribeError] = useState(false);

  const [addLocationSubscriber] = useAddLocationSubscriberMutation();

  const onSubscribeSubmit = async (values) => {
    try {
      await addLocationSubscriber({
        id: location.id,
        email: values.email,
        frequency: values.frequency,
      }).unwrap().then(() => {
        setSubscribeSuccess(true);
      });
    } catch (err) {
      console.error('Failed to subscribe to Location: ', err);
      setSubscribeError(true);
    }
  };

  return (
    <div className={cn(sidebarStyles.Sidebar, styles.LocationSidebar)}>

      { location.pod &&
        <div className={sidebarStyles.Sidebar_item}>
          <div className={sidebarStyles.Sidebar_header}>
            <h3 className='u-phosphate u-mb0'>Get the schedule by email</h3>
          </div>
          <div className={sidebarStyles.Sidebar_padding}>
            <p>A weekly or daily email with the upcoming food {vehicleType} schedule and menus for this spot.</p>

            { !subscribeSuccess && !subscribeError &&
              <LocationSubscribeForm onSubmit={onSubscribeSubmit} />
            }
            { subscribeSuccess && <p>You’re subscribed.</p> }
            { subscribeError && <p>We couldn’t subscribe you. Refresh the page and try again.</p> }
          </div>
        </div>
      }

      {/* Outside the card, so a Maps error drops the whole card rather than
          leaving an empty shadowed box. */}
      { location && Number.isFinite(location.latitude) && Number.isFinite(location.longitude) &&
        <ErrorBoundary name='LocationMap'>
          <div className={sidebarStyles.Sidebar_item}>
            <LocationMap location={location} />
          </div>
        </ErrorBoundary>
      }

    </div>
  );
}

LocationSidebar.propTypes = {
  location: PropTypes.object.isRequired,
};

export default LocationSidebar;
